<template>
    <Header></Header>
    <div class="container _mypage sub_page">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01 _medium blink3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_02 _small blink_zoom2"><img src="img/b_icon_02.png" /></i>
                <i class="deco_03 _small spin_blink2 D_only"><img src="img/b_icon_01.png" /></i>
                <i class="deco_04 _small spin1 D_only"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/mypage_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>마이페이지</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeType(0)" :class="[state.type === 0 ? 'active' : '']"><a href="javascript:void(0)">회원정보수정</a></li>
                    <template v-if="!user.userInfo.isAdmin">
                        <li @click="changeType(1)" :class="[state.type === 1 ? 'active' : '']"><a href="javascript:void(0)">1:1 문의</a></li>
                        <li @click="changeType(2)" :class="[state.type === 2 ? 'active' : '']"><a href="javascript:void(0)">내가 쓴 게시글</a></li>
                        <li @click="changeType(3)" :class="[state.type === 3 ? 'active' : '']"><a href="javascript:void(0)">신청내역</a></li>
                    </template>
                </ul>
            </div>
        </section>

        <MyInfo v-if="state.type === 0"></MyInfo>
        <template v-if="!user.userInfo.isAdmin">
            <InquiryList v-if="state.type === 1"></InquiryList>
            <MyContentsList v-else-if="state.type === 2"></MyContentsList>
            <ApplyList v-else-if="state.type === 3"></ApplyList>
        </template>
    </div>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        Header,
        Footer,
        ApplyList,
        InquiryList,
        MyContentsList,
        MyInfo,
        reactive,
        globalStore,
        onMounted,
        watch,
        userStore,
        ModalDefault,
        router,
        useRoute,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ApplyList, InquiryList, MyContentsList, MyInfo, ModalDefault },
        setup() {
            const global = globalStore();
            const route = useRoute();
            const user = userStore();
            const state = reactive({
                type: -1 as number,
                subMenuOpen: false as boolean,
                subMenuName: '회원정보수정' as string,
            });

            onMounted(() => {
                init();
            });

            watch(
                () => route.query.type,
                () => {
                    const type = Number(route.query.type);
                    if (route.query.type) {
                        if (type && typeof type === "number" && !isNaN(type)) {
                            state.type = type;
                        } else {
                            state.type = 0;
                        }
                    } else {
                        state.type = 0;
                    }
                },
            );

            watch(state, () => {
                global.setMypageType(state.type);
            });

            const init = () => {
                state.type = global.type > 0 ? global.type : 0;
                changeType(state.type);
            };

            const changeType = (type: number) => {
                if (!user.userInfo.isAdmin) {
                    state.type = type;
                    router.push({ path: "/mypage", query: { type: state.type } });
                    state.subMenuOpen = false;
                    switch (type) {
                        case 0:
                            state.subMenuName = '회원정보수정';
                            break;
                        case 1:
                            state.subMenuName = '1:1 문의';
                            break;
                        case 2:
                            state.subMenuName = '내가 쓴 게시글';
                            break;
                        case 3:
                            state.subMenuName = '신청내역';
                            break;
                    }
                }
            };

            const subMenuTab = () =>{
                 if (window.innerWidth <= 768) {
               state.subMenuOpen = !state.subMenuOpen;
                }
            }

            return { state, global, user, changeType, subMenuTab };
        },
    };
</script>
